/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AdvancedShippingNotesResponseV3 } from '../../models/advanced-shipping-notes-response-v-3';
import { KeyType } from '../../models/key-type';

export interface GetAdvancedShippingNotesV3$Params {
  organizationSiteKey: KeyType;
}

export function getAdvancedShippingNotesV3(http: HttpClient, rootUrl: string, params: GetAdvancedShippingNotesV3$Params, context?: HttpContext): Observable<StrictHttpResponse<AdvancedShippingNotesResponseV3>> {
  const rb = new RequestBuilder(rootUrl, getAdvancedShippingNotesV3.PATH, 'get');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AdvancedShippingNotesResponseV3>;
    })
  );
}

getAdvancedShippingNotesV3.PATH = '/organization-sites/{organizationSiteKey}/consignee/advanced-shipping-notes';
